export default __webpack_public_path__ + "static/media/lock.0d49bf4d.svg";